// @ts-ignore
import i18n from '@/shared/plugins/i18n';

export const $i18n = i18n.global;

function baseT(fn: string, ...args: any[]) {
  const alias = args[0];

  if (!$i18n) {
    return alias;
  }

  return ($i18n as any)[fn](...args);
}

export function $t(...args: any[]) {
  return baseT('t', ...args);
}

export function $tc(...args: any[]) {
  return baseT('tc', ...args);
}
